module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('text', {
    staticClass: ["dof-colmo-tag"],
    style: _vm.currentStyle
  }, [_vm._v(_vm._s(_vm.content))])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-f0577fe8!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-colmo-tag/index.vue
// module id = 675
// module chunks = 0 1